import { defineComponent as _defineComponent } from 'vue'
interface LoadingProps {
  loading: boolean;
  fullscreen?: boolean;
  showText?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Loading',
  props: {
    loading: { type: Boolean },
    fullscreen: { type: Boolean },
    showText: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  loading: boolean;
  fullscreen?: boolean;
  showText?: boolean;
};




return { __sfc: true,props }
}

})